"use client";

import { TriangleAlert } from "lucide-react";

import { Response } from "@/components/ui/shadcn-io/ai/response";
import { cn } from "@/lib/utils";

interface CommandV2StreamErrorBannerProps {
    text: string;
    className?: string;
}

export function CommandV2StreamErrorBanner({
    text,
    className,
}: CommandV2StreamErrorBannerProps) {
    return (
        <div
            role="alert"
            className={cn(
                "relative overflow-hidden rounded-xl",
                "border border-amber-200/60 bg-gradient-to-r from-amber-50/90 to-orange-50/50",
                "px-3 py-2.5",
                "dark:border-amber-800/45 dark:from-amber-950/45 dark:to-orange-950/25",
                className
            )}
        >
            <div
                className="pointer-events-none absolute inset-y-1.5 left-0 w-0.5 rounded-full bg-gradient-to-b from-amber-400 to-orange-400 dark:from-amber-500 dark:to-orange-500"
                aria-hidden
            />
            <div className="flex items-start gap-2.5 pl-1">
                <div className="mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-md bg-amber-100/90 dark:bg-amber-900/50">
                    <TriangleAlert className="size-3.5 text-amber-600 dark:text-amber-300" />
                </div>
                <Response className="min-w-0 flex-1 text-[13px] leading-snug text-amber-950/90 dark:text-amber-50/90 [&_p]:m-0 [&_strong]:font-semibold">
                    {text}
                </Response>
            </div>
        </div>
    );
}
